import defaultInfoModalState from './default-modal';

export default {
  // Some UI values
  ui: {
    responsiveHeader: null,
    responsiveContent: null,

    isMobile: false,
    orientation: 'portrait',

    initialLoading: true,
    // Info modal
    infoModal: defaultInfoModalState,
    loadingModalVisible: false,

    emailChangeProcess: {
      apiCallState: 'none'
    },

    phoneChangeProcess: {
      apiCallState: 'none'
    },
    logo: null,
    theme: {},
    title: '',
    favicon: '',
    appType: 'web',
    modules: []
  },

  devices: {
    camera: {
      stream: null,
      inputs: []
    }
  },

  user: {
    fullName: null,
    firstName: undefined,
    middleName: null,
    lastName: undefined,
    username: undefined,
    email: undefined,
    phone: {
      prefix: null,
      number: null
    },
    address: {
      street: undefined,
      city: undefined,
      country: undefined,
      zip: undefined
    },
    birthday: {
      day: undefined,
      month: undefined,
      year: undefined
    },
    verifications: {
      phone: undefined
    },
    auth: {
      emailVerificationChecked: false,
      emailVerificationDisabled: false,
      smsVerificationChecked: false,
      smsVerificationDisabled: false,
      totpVerificationChecked: false,
      totpVerificationDisabled: false,
      u2fVerificationChecked: false,
      u2fVerificationDisabled: false,
      u2fUrl: null
    },
    kyc: {
      id: '',
      status: '',
      documents: null,
      approvedAddress: false,
      approvedIdentity: false,
      approvedSelfie: false,
      allowedTypes: [],
      subtypes: [],
      createdAt: '',
      updatedAt: ''
    },
    available2fa: [],
    nonEditableFields: ['email', 'phoneNumber'],
    status: null
  },
  backToAppUrl: '',
  customFields: {},
  nationalities: [],
  countries: []
};
